// Logger utility to control console output based on environment flags
// The goal is to silence verbose diagnostics in production while still allowing
// developers to opt-in to detailed output by setting VITE_DEBUG_LOGGING=true.

let debugEnabled = import.meta.env.VITE_DEBUG_LOGGING === 'true';

/* eslint-disable no-console */
export const logger = {
  log: (...args: unknown[]) => {
    if (debugEnabled) console.log(...args);
  },
  warn: (...args: unknown[]) => {
    if (debugEnabled) console.warn(...args);
  },
  error: (...args: unknown[]) => {
    // Always surface errors
    console.error(...args);
  }
};

// Optionally expose a quick helper to toggle at runtime (dev tools)
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.__EOA_DEBUG__ = (state: boolean) => { debugEnabled = state; console.info(`Debug logging ${state ? 'enabled' : 'disabled'}`); };
/* eslint-enable no-console */